import { GeneralLedgersKeyType } from '../../keys';

const generalLedgersKeys: GeneralLedgersKeyType = {
  createSubbook: 'Create subbook',
  editSubbook: 'Edit subbook',
  subbookName: 'Subbook name'
};

export default generalLedgersKeys;
